import * as React from 'react';
import './formStyles.scss'
import Req from "../Req";

export const WYMAGANIA_HASLA = 'Minimum 8 znaków, duże i małe litery oraz znaki specjalne (@#$%^&+=).';
export const HINT_MIGRACJA = 'Dane przeniesione z dotychczasowego konta – nie można ich zmienić.';

// POLE FORMULARZA

let licznikPol = 0;

interface FormFieldProps {
    label: React.ReactNode,
    required?: boolean,
    hint?: React.ReactNode,
    error?: React.ReactNode,
    status?: React.ReactNode,
    labelCol?: string,
    fieldCol?: string,
    id?: string,
    children: React.ReactElement
}

export const FormField = (props: FormFieldProps) => {
    const [autoId] = React.useState(() => 'pole-' + (++licznikPol));
    const id = props.id || autoId;
    const idPodpowiedzi = id + '-podpowiedz';
    const idKomunikatu = id + '-komunikat';
    const opisy = [
        props.hint ? idPodpowiedzi : null,
        (props.error || props.status) ? idKomunikatu : null
    ].filter(Boolean).join(' ');

    const pole = React.cloneElement(props.children, {
        id,
        required: props.required || props.children.props.required,
        'aria-required': props.required ? true : undefined,
        'aria-invalid': props.error ? true : undefined,
        'aria-describedby': opisy || undefined
    });

    return <>
        <div className={props.labelCol || 'col-sm-2'}>
            <label htmlFor={id} className={'field-label'}>{props.label}{props.required && <Req/>}</label>
        </div>
        <div className={props.fieldCol || 'col-sm-10'}>
            {pole}
            {props.hint && <small id={idPodpowiedzi} className={'field-hint'}>{props.hint}</small>}
            <div id={idKomunikatu} aria-live={'polite'}>
                {props.error ?
                    <p className={'field-error'}><i className={'fa fa-exclamation-circle'} aria-hidden={'true'}/> {props.error}</p>
                    :
                    (props.status ? <p className={'field-status'}>{props.status}</p> : null)
                }
            </div>
        </div>
    </>
}

export const RequiredLegend = () =>
    <p className={'required-legend'}>Pola oznaczone <span className={'req'}>*</span> są wymagane.</p>

export const focusFirstInvalid = (kontener: HTMLElement | null) => {
    if (!kontener) return;
    const pole = kontener.querySelector<HTMLElement>('[aria-invalid="true"]');
    if (pole) pole.focus();
}

// CHECKBOX

interface checkboxProps {
    required: boolean,
    name: string,
    checked: any,
    handleOnChange: any,
    label: React.ReactNode
}

export const CheckBox = (props: checkboxProps) => {
    return <label className={'checkbox-container'}>
        <input type="checkbox" checked={props.checked} required={props.required} name={props.name} onChange={props.handleOnChange}/>
        <span className={"checkbox-checkmark"} aria-hidden={'true'}/>
        <span className={'checkbox-span'}>{props.label}</span>
    </label>
}

CheckBox.defaultProps = {}
